module.exports = __webpack_public_path__ + "static/media/engineering_white_24dp.f05dd50f.svg";